import React, { Component } from 'react';
import * as Progress    from 'react-native-progress';
import * as ImagePicker from 'expo-image-picker';
import { StyleSheet, View, TextInput, ActivityIndicator, SafeAreaView, Modal, TouchableWithoutFeedback, Platform, TouchableOpacity, Image } from 'react-native';
import { Screen, Button, Input, Routes, MediaModal, Icon, Line, Text, Colors }   from '../components';
import { HomePetsList, MessageList } from '../containers';
import { StringUtils, DateUtils } from '../utils';
import ConsultationController from '../controllers/consultationController';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigate } from 'react-router-dom';

class CompletedConsultationsScreen_Base extends Component {

  constructor(props) {
    super(props);

    console.log('props', props)

    this.state = {
      message_text: '',
      care_consultation: null,
      display_attachment_modal: false,
      loading_send_attachment: false,
      messages: [],
      consultations: []
    }

    this.selectConsultation = this.selectConsultation.bind(this);
  }

  async componentDidMount() {

    let params     = await AsyncStorage.getItem('link_params');
    let partner_id = await AsyncStorage.getItem('partner_id');
    let consultation_id;

    if(params) {
      params = JSON.parse(params);

      console.log('params', params)

      consultation_id = params.consultation_id;
    }

    let completed_consultations = await ConsultationController.getCompletedConsultations(partner_id);

    if(completed_consultations && completed_consultations.success && completed_consultations.data && completed_consultations.data.care_consultations) {
      let consultations = completed_consultations.data.care_consultations;

      this.setState({
        consultations
      }, () => {
        if(consultation_id) {
          let selected_consultation = consultations.filter((consultation) => {return consultation._id === consultation_id});

          console.log('selected_consultation', selected_consultation);

          if(selected_consultation && selected_consultation.length > 0) {
            this.selectConsultation(selected_consultation[0])
          }
        }
      })
    }
  }

  selectConsultation(care_consultation) {
    let is_chat       = care_consultation && care_consultation.type && care_consultation.type === 'CHAT'       ? true : false;
    let is_video      = care_consultation && care_consultation.type && care_consultation.type === 'VIDEO'      ? true : false;
    let is_live_video = care_consultation && care_consultation.type && care_consultation.type === 'LIVE_VIDEO' ? true : false;

    if (is_chat) {
      let path = `${Routes.CONSULTATION_CHAT}?consultation_id=${care_consultation._id}`

      if(Platform.OS === 'web') {
        this.props.navigate(path);
      } else {
        this.props.navigate(Routes.CONSULTATION_CHAT, {consultation_id: care_consultation._id})
      }
    }

    if (is_video) {
      let path = `${Routes.CONSULTATION_VIDEO_APPOINTMENT}?consultation_id=${care_consultation._id}`

      if(Platform.OS === 'web') {
        this.props.navigate(path);
      } else {
        this.props.navigate(Routes.CONSULTATION_VIDEO_APPOINTMENT, {consultation_id: care_consultation._id})
      }
    }

    if (is_live_video) {
      let path = `${Routes.CONSULTATION_VIDEO_APPOINTMENT}?consultation_id=${care_consultation._id}`

      if(Platform.OS === 'web') {
        this.props.navigate(path);
      } else {
        this.props.navigate(Routes.CONSULTATION_VIDEO_APPOINTMENT, {consultation_id: care_consultation._id})
      }
    }
  }

  render_consultations() {
    let consultations = this.state.consultations;
    let dislay_empty  = consultations && consultations.length === 0 ? true : false;
    return (
      <View style={{ padding: 20 }}>
          { dislay_empty ? <View style={{ padding: 20 }}><Text style={{ textAlign: 'center', color: 'grey', fontSize: 16 }}>You do not have any Completed Consultations</Text></View> : null }
          {consultations.map((consultation, index) => {
            let is_chat       = consultation && consultation.type && consultation.type === 'CHAT'       ? true : false;
            let is_video      = consultation && consultation.type && consultation.type === 'VIDEO'      ? true : false;
            let is_live_video = consultation && consultation.type && consultation.type === 'LIVE_VIDEO' ? true : false;

            let patient  = consultation && consultation.patient ? consultation.patient : {};
            let name     = StringUtils.displayName(patient);

            let date_obj = consultation.resolved_at ? new Date(consultation.resolved_at) : consultation.updated_at;
            let date_num = DateUtils.getDateNumber(date_obj);
            let add_zero = date_num.toString().length === 1;
            let date_str = DateUtils.getShortMonth(date_obj) + ' ' + DateUtils.getDateNumber(date_obj);
                date_str = add_zero ? DateUtils.getShortMonth(date_obj) + ' 0' + DateUtils.getDateNumber(date_obj) : date_str;
                date_str = !consultation.updated_at ? '' : date_str;

            let icon     = is_chat       ? 'comment' : '';
                icon     = is_video      ? 'video'   : icon;
                icon     = is_live_video ? 'video' : icon;

            let type_lbl = is_chat       ? 'Chat'  : '';
                type_lbl = is_video      ? 'Video' : type_lbl;
                type_lbl = is_live_video ? 'Live Video' : type_lbl;


            return  <View key={index}>
              <TouchableOpacity style={styles.consultation_list_item}
                                onPress={ () => this.selectConsultation(consultation) }>
                <View>
                  <Text style={{ fontSize: 16, fontWeight: '500', color: '#040415' }}>{ name }</Text>
                  <View style={{ flexDirection: 'row' }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center', width: 70 }}>
                      <Icon name={icon} solid={true} size={12} color={Colors.PRIMARY} style={{ marginRight: 7, marginTop: 5 }}/>
                      <Text style={{ fontSize: 14, color: '#575762', marginTop: 5 }}>{ date_str }</Text>
                    </View>
                      <Text style={{ fontSize: 14, color: '#575762', marginTop: 5, marginRight: 8 }}>{ '|' }</Text>
                      <Text style={{ fontSize: 14, color: '#575762', marginTop: 5 }}>{ type_lbl }</Text>
                  </View>
                </View>
                <Icon name={'chevron-right'} solid={true} size={15} color={'#cccccc'} />
              </TouchableOpacity>
              <Line />
            </View>
            })
          }
      </View>
    )
  }

  render() {
    return (
      <Screen navigation={this.props.navigation} scroll={true} title='Past Consultations'>
        { this.render_consultations() }
      </Screen>
    );
  }
}

function CompletedConsultationsScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <CompletedConsultationsScreen_Base {...props} navigate={navigate} />
  } else {
    return  <CompletedConsultationsScreen_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({
  input_section_container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'pink',
    padding: 10
  },
  message_text_input: {
    backgroundColor: 'white',
    borderRadius: 30,
    padding: 12,
    paddingTop: 14,
    flex: 1,
  },
  main_container: {

  },
  consultation_list_item: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 20,
    paddingBottom: 20
  }
});

export default CompletedConsultationsScreen
